import { filespaceFormatValidator, FilespaceVersion, mapFilespaceFormatToVersion, } from '@lucidlink/dto/validation';
// WebFs refuses every data store call below this version (format 3.5).
export const MIN_LUCID_LINK_CONNECT_FILESPACE_VERSION = FilespaceVersion.V9;
export const isLucidLinkConnectSupported = (format) => {
    const parsedFormat = filespaceFormatValidator.safeParse(format);
    if (!parsedFormat.success) {
        return false;
    }
    return (mapFilespaceFormatToVersion(parsedFormat.data) >=
        MIN_LUCID_LINK_CONNECT_FILESPACE_VERSION);
};
